import { Editor } from 'grapesjs';
import i18n from 'i18next';
import { heroBlocks } from './heroBlocks';
import { contentBlocks } from './contentBlocks';
import { conversionBlocks } from './conversionBlocks';
import { layoutBlocks } from './layoutBlocks';
import { whatsappBlocks } from './whatsappBlocks';

// Map each block id to its i18n label key. Falls back to the PT literal
// coming from the block definition when the translation is missing.
const translateLabel = (id: string, fallback: string): string => {
  if (id === 'custom-embed') {
    return i18n.t('pageBuilder.blocks.customEmbed.label', fallback) || fallback;
  }
  return i18n.t(`pageBuilder.blocks.labels.${id}`, fallback) || fallback;
};

// Map each PT category literal to its i18n category key.
const CATEGORY_KEY_BY_PT: Record<string, string> = {
  'Seções Hero': 'hero',
  'Imagens': 'images',
  'Conteúdo': 'content',
  'Elementos': 'elements',
  'Layout': 'layout',
  'Conversao': 'conversion',
  'Conversão': 'conversion',
  'Texto': 'text',
  'WhatsApp': 'whatsapp',
  'Avançado': 'advanced',
};

const translateCategory = (fallback: string): string => {
  const key = CATEGORY_KEY_BY_PT[fallback];
  if (key === 'advanced') {
    return i18n.t('pageBuilder.blocks.customEmbed.category', fallback) || fallback;
  }
  if (key) {
    return i18n.t(`pageBuilder.blocks.categories.${key}`, fallback) || fallback;
  }
  return fallback;
};

export const registerCustomBlocks = (editor: Editor): void => {
  const blockManager = editor.BlockManager;

  const allBlocks = [
    ...heroBlocks,
    ...contentBlocks,
    ...conversionBlocks,
    ...layoutBlocks,
    ...whatsappBlocks,
  ];

  allBlocks.forEach((block) => {
    blockManager.add(block.id, {
      // Translate at REGISTRATION time (i18next is fully initialized by then,
      // so module-load timing issues are avoided).
      label: translateLabel(block.id, block.label as string),
      category: translateCategory(block.category as string),
      content: block.content,
      media: block.media,
      attributes: block.attributes,
    });
  });
};
